import device from 'common/support/device';
import { ttsInitEventName } from 'support/tts/TextToSpeechManager';
import { Platform } from 'app-types';

export const initializeTTS = (platform: Platform): void => {
  if (
    platform === 'vizio' ||
    platform === 'lg-webos' ||
    platform === 'samsung-tizen'
  ) {
    // Vizio stated we don't need to use the VIZIO_TTS events
    // Chromevox has an internal toggle determined by vizio TTS system settings
    // This means we can always have TTS enabled on Vizio since the system
    // will internally resolve whether to read out TTS or not
    document.dispatchEvent(new Event(ttsInitEventName));
  } else if (device.accessibleAudioEnabled()) {
    document.dispatchEvent(new Event(ttsInitEventName));
  }
};